/**
 * @module app.cd
 */

import { autoinject, bindingMode } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { apiCall } from 'app/shared/lib/api/api';
import { AuthService } from 'app/cd/services/auth-service';
import * as CD from 'app/cd/models/essette-api';


@autoinject()
export class AuthInformation extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable.stringNull({ defaultBindingMode: bindingMode.toView, changeHandler: 'reload' })
    protected authId: string | null = null;

    protected auth: CD.Auth | null = null;


    ////****************** Element References ***************************************////



    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(private readonly service: AuthService,
        ...rest: any[]) {
        super(...rest);
        this.logger.source = this;
    }
    //protected async activate(params: any, routeConfig: RouteConfig, navInstruction: NavigationInstruction): Promise<void> {}
    //protected created(owningView: View, myView: View): void { }
    //protected bind(bindingContext: Object, overrideContext: Object): void { }
    //protected attached(): void { }
    //protected deactivate(): void { }
    //protected detached(): void { }
    //protected unbind(): void { }



    ////****************** Events ***************************************************////
    protected async reload(): Promise<void> {
        if(this.authId) {
            await this.loadAuth(this.authId);
        }
    }


    ////****************** Functions ************************************************////



    ////****************** Service Calls ********************************************////
    @apiCall
    private async loadAuth(authId: string): Promise<void> {
        if(!authId) return;

        const includes: string[] = [
            'priority',
            'status',
            'payStatus',
            'member',
            'member.plan.lineofbusiness',
            'member.plan.healthplan',
            'placeOfService',
            'userFields',
            'metadata.created.byuser',
            'metadata.modified.byuser',
            'custom.target.definitions'
        ];

        try {
            this.state.beginLoad();

            const response = await this.service.loadAuth(authId, includes);
            this.auth = response.results[0];
        }
        catch(error) {
            throw error;
        }
        finally {
            this.state.endLoad();
        }
    }
}
